import AffiliateService from './services';
import AffiliateTypes from './types';

export const listAffiliatesNotifications = (pagination: any, status: 'pending' | 'approved' | 'reproved', order: string | null) =>
  AffiliateTypes.notifications.createAction(() => AffiliateService.listAffiliates(pagination, status, order, true));

export const listAffiliates = (pagination: any, status: 'pending' | 'approved' | 'reproved', order: string | null, coproducer: boolean = false) =>
  AffiliateTypes.listAffiliates.createAction(() => AffiliateService.listAffiliates(pagination, status, order, coproducer));

export const exportAffiliates = (status: 'pending' | 'approved' | 'reproved', order: string | null) =>
  AffiliateTypes.exportAffiliates.createAction(() => AffiliateService.exportAffiliates(status, order));

export const configCustomCommission = (affiliateId: any, type: any, value: any) =>
  AffiliateTypes.configCustomCommission.createAction(() => AffiliateService.configCustomCommission(affiliateId, type, value));

export const moderateAffiliate = (affiliateId: any, status: any) =>
  AffiliateTypes.moderateAffiliate.createAction(() => AffiliateService.moderateAffiliate(affiliateId, status));

export const moderateMultipleAffiliates = (affiliatesIds: Array<number>, status: 'A' | 'R') =>
  AffiliateTypes.moderateMultipleAffiliates.createAction(() => AffiliateService.moderateMultipleAffiliates(affiliatesIds, status));
